export default __webpack_public_path__ + "static/media/LOGO_6.456fb40c.svg";